/* unplugin-vue-components disabled */import { render } from "./builder-inputs.vue?vue&type=template&id=4db90bdf&scoped=true"
import script from "./builder-inputs.vue?vue&type=script&lang=js"
export * from "./builder-inputs.vue?vue&type=script&lang=js"

import "./builder-inputs.vue?vue&type=style&index=0&id=4db90bdf&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db90bdf"],['__file',"src/components/builder/builder-inputs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4db90bdf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4db90bdf', __exports__)) {
    api.reload('4db90bdf', __exports__)
  }
  
  module.hot.accept("./builder-inputs.vue?vue&type=template&id=4db90bdf&scoped=true", () => {
    api.rerender('4db90bdf', render)
  })

}


export default __exports__